import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const PolicyLink = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const IntroText = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  marginBottom: theme.spacing(2),
}));

export const KeyPointsTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}));

